import { API } from './index';

export function getGamesData(): Promise<any> {
    return API.get('control/get-games-data');
}

export function getGameData(projectName: string): Promise<any> {
    return API.get(`control/get-game-data?projectName=${projectName}`);
}

export function getSingleGameData(projectName: string): Promise<any> {
    return API.get(`control/get-single-game-data?projectName=${projectName}`);
}